import { createSlice } from "@reduxjs/toolkit";

const initial_state = {
  alertsList:[],
  currentPage: 1,
  lastPage: 1,
  totalAlertsCount: 6,
  perPageCount: 10,
  alertsLoading: false,
  createAlertLoading: false,
  updateAlertLoading: false,
  deleteAlertLoading: false,
  search: "",
  searchModal: false,
  userLocation: null, // Global location state
};

const alertsReducer = createSlice({
  name: "Alerts",
  initialState: initial_state,
  reducers: {
    updateAlerts: (state, { payload }) => {
      return { ...state, ...payload };
    },
  },
});

export const { updateAlerts } = alertsReducer.actions;
export default alertsReducer.reducer;
